import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { RenderProps } from 'react-native-spotlight-tour';
import { useDispatch } from 'react-redux';
import { setHasCompletedNavigationTour } from 'store/slices/userDeviceSessionData';

type SpotlightProps = RenderProps & {
  spotlightTitle?: string;
  spotlightDescription?: string;
  isLastItem?: boolean;
  arrowAlign?: 'left' | 'center' | 'right' | 'none';
  arrowPosition?: 'top' | 'bottom';
};

const SpotlightComponent: React.FC<SpotlightProps> = ({
  spotlightTitle,
  spotlightDescription,
  isLastItem,
  arrowAlign = 'none',
  arrowPosition,
  ...rest
}) => {
  const dispatch = useDispatch();

  const getArrowAlign = (arrow: 'left' | 'center' | 'right' | 'none'): number => {
    switch (arrow) {
      case 'left':
        return 250;
      case 'center':
        return 140;
      case 'right':
        return 15;
      case 'none':
        return 0;
      default:
        return 0;
    }
  };

  function CompletSpotLightTour() {
    rest.stop();
    dispatch(setHasCompletedNavigationTour());
  }

  return (
    <View style={styles.container}>
      {/* Arrow */}
      <View
        style={[
          styles.arrow,
          {
            borderBottomWidth: arrowPosition === 'top' ? 20 : 0,
            borderTopWidth: arrowPosition === 'bottom' ? 15 : 0,
            borderTopColor: arrowPosition === 'bottom' ? '#001FE6' : 'transparent',
            borderBottomColor: arrowPosition === 'top' ? '#001FE6' : 'transparent',
            right: getArrowAlign(arrowAlign),
            top: arrowPosition === 'top' ? 0 : undefined,
            bottom: arrowPosition === 'bottom' ? 0 : undefined,
          },
        ]}
      />
      <View style={styles.contentBox} {...rest}>
        <Text style={styles.title}>{spotlightTitle}</Text>
        <Text style={styles.description}>{spotlightDescription}</Text>
        {isLastItem ? (
          <View style={styles.hStackCenter}>
            <TouchableOpacity
              onPress={CompletSpotLightTour}
              style={styles.finishButton}
              activeOpacity={0.8}>
              <Text style={styles.finishButtonText}>Finalizar!</Text>
            </TouchableOpacity>
          </View>
        ) : (
          <View style={styles.hStackSpace}>
            <TouchableOpacity
              onPress={CompletSpotLightTour}
              style={styles.skipButton}
              activeOpacity={0.8}>
              <Text style={styles.skipButtonText}>Pular</Text>
            </TouchableOpacity>
            <TouchableOpacity onPress={rest.next} style={styles.nextButton} activeOpacity={0.8}>
              <Text style={styles.nextButtonText}>Próximo</Text>
            </TouchableOpacity>
          </View>
        )}
      </View>
    </View>
  );
};

export default SpotlightComponent;

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    backgroundColor: 'transparent',
    paddingVertical: 10,
  },
  arrow: {
    width: 0,
    height: 0,
    borderRightWidth: 15,
    borderLeftWidth: 15,
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    position: 'absolute',
  },
  contentBox: {
    maxWidth: 320,
    backgroundColor: '#001FE6',
    padding: 20,
    borderRadius: 16,
  },
  title: {
    color: '#fff',
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 5,
  },
  description: {
    color: '#fff',
    fontSize: 14,
  },
  hStackCenter: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 15,
  },
  hStackSpace: {
    flexDirection: 'row',
    marginTop: 15,
    gap: 16,
  },
  finishButton: {
    width: 140,
    height: 40,
    backgroundColor: '#fff',
    borderRadius: 32,
    justifyContent: 'center',
    alignItems: 'center',
  },
  finishButtonText: {
    color: '#001FE6',
    fontSize: 14,
    fontWeight: 'bold',
  },
  skipButton: {
    width: 120,
    height: 40,
    borderRadius: 32,
    borderWidth: 1,
    borderColor: '#fff',
    backgroundColor: 'transparent',
    justifyContent: 'center',
    alignItems: 'center',
  },
  skipButtonText: {
    color: '#fff',
    fontSize: 14,
  },
  nextButton: {
    width: 120,
    height: 40,
    backgroundColor: '#fff',
    borderRadius: 32,
    justifyContent: 'center',
    alignItems: 'center',
  },
  nextButtonText: {
    color: '#001FE6',
    fontSize: 14,
    fontWeight: 'bold',
  },
});
